import React from 'react';

import {EvaluatedTable} from 'notebook/tables/excess/Evaluator';
import {Table} from 'notebook/tables/TableConstants';
import APIUtil from 'util/APIUtil';

import {extractTableDataForSuggestions, GetTableDataFn} from './extractTableDataForSuggestions';
import SuggestedPlotsCallout, {isCalloutEligible} from './SuggestedPlotsCallout';
import SuggestedPlotsDropdown from './SuggestedPlotsDropdown';
import {arePlotSuggestionsSupportedSync} from './suggestPlotsUtils';

interface PlainTableSuggestedPlotsButtonProps {
  fileId: string;
  table: Table;
  computedTable: EvaluatedTable;
  /**
   * Whether the table is rendered in a read-only context (lacking edit permission, someone else holds
   * the lock, or a historical version). The callout is an editing affordance, so skip it when true.
   */
  viewer?: boolean;
}

export default function PlainTableSuggestedPlotsButton({
  fileId,
  table,
  computedTable,
  viewer = false,
}: PlainTableSuggestedPlotsButtonProps): JSX.Element | null {
  if (!arePlotSuggestionsSupportedSync()) {
    return null;
  }
  if (!APIUtil.isEntry(fileId) && !APIUtil.isDocument(fileId)) {
    return null;
  }

  const getTableData: GetTableDataFn = () => extractTableDataForSuggestions(table, computedTable);
  // For plain tables the header lives in `columnLabels` and is only prepended to `table.table` at
  // render/export time, so `table.table` holds only data rows. `table.table` includes a header row at
  // index 0 only when `headerRow` is toggled on, so subtract it just in that case.
  const rowCount = table.headerRow ? table.table.length - 1 : table.table.length;

  return (
    <SuggestedPlotsCallout fileId={fileId} isEligible={!viewer && isCalloutEligible({rowCount})}>
      <SuggestedPlotsDropdown entryId={fileId} tableName={table.name} getTableData={getTableData} />
    </SuggestedPlotsCallout>
  );
}
